import { Button, Form, Input, Typography } from "antd";
import { useTranslation } from "react-i18next";
import useStyles from "./styles";
import { useTheme } from "antd-style";
import { useLink, useRegister } from "@refinedev/core";
import { usePageTitle } from "@/hooks/usePageTitle";
import { useSearchParams, useNavigate } from "react-router-dom";

const authCredentials = {
  email: "demo@demo.com",
  password: "demodemo",
};

export const RegisterPage = () => {
  const { t } = useTranslation();
  const token = useTheme();
  const Link = useLink();
  const { mutate: register, isLoading } = useRegister();
  const [searchParams] = useSearchParams();  
  const pToken = searchParams.get("token");
  usePageTitle(t("auth.register", "VIA AIOps"));
  const navigate = useNavigate();

  const { styles } = useStyles();

  const adminSignupForm = (
    <Form
      layout="vertical"
      size="small"
      requiredMark={false}
      onFinish={(values) => register({...values, token:pToken || ""})}
    >
      <Form.Item
        name="tenant"
        label={t("pages.login.fields.tenantname", "Tenant Name")}
        rules={[
          {
            required: true,
            message: t(
              "pages.login.errors.requiredTenantname",
              "Tenant name is required",
            ),
          },
        ]}
      >
        <Input
          placeholder={t("pages.login.fields.tenantname", "Tenant Name")}
        />
      </Form.Item>

      <Form.Item
        name="user"
        label={t("pages.login.fields.username", "Username")}
        rules={[
          {
            required: true,
            message: t(
              "pages.login.errors.requiredUsername",
              "Username is required",
            ),
          },
        ]}
      >
        <Input placeholder={t("pages.login.fields.username", "Username")} />
      </Form.Item>
      <Form.Item
        name="email"
        label={t("pages.login.fields.email", "Email")}
        rules={[
          {
            required: true,
            message: t("pages.login.errors.requiredEmail", "Email is required"),
          },
        ]}
      >
        <Input placeholder={t("pages.login.fields.email", "Email")} />
      </Form.Item>

      <Form.Item
        name="instance"
        label={t("pages.login.fields.instancename", "Instance Name")}
        rules={[
          {
            required: true,
            message: t(
              "pages.login.errors.requiredInstancename",
              "Instance name is required",
            ),
          },
        ]}
      >
        <Input
          placeholder={t("pages.login.fields.instancename", "Instance Name")}
        />
      </Form.Item>

      <Form.Item
        name="domain_prefix"
        label={t("pages.login.fields.subdomain", "Subdomain")}
        rules={[
          {
            required: true,
            message: t(
              "pages.login.errors.requiredSubdomain",
              "Subdomain is required",
            ),
          },
        ]}
      >
        <Input/>
      </Form.Item>

      <Form.Item
        name="password"
        label={t("pages.login.fields.password", "Password")}
        rules={[
          {
            required: true,
            message: t(
              "pages.login.errors.requiredPassword",
              "Password is required",
            ),
          },
          ...PasswordRule(t),
        ]}
      >
        {/* <Input
          type="password"
          autoComplete="current-password"
          placeholder="●●●●●●●●"
        /> */}
        <Input.Password />
      </Form.Item>

      <Form.Item
        name="confirmpassword"
        label={t("pages.login.fields.confirmpassword", "Confirm Password")}
        dependencies={["password"]}
        rules={[
          {
            required: true,
            message: t(
              "pages.login.errors.requiredConfirmPassword",
              "Confirm Password is required",
            ),
          },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue("password") === value) {
                return Promise.resolve();
              }
              return Promise.reject(
                new Error(
                  t(
                    "pages.login.errors.notmatch",
                    "The two passwords do not match!",
                  ),
                ),
              );
            },
          }),
        ]}
      >
        {/* <Input
          type="password"
          autoComplete="current-password"
          placeholder="●●●●●●●●"
        /> */}
        <Input.Password />
      </Form.Item>

      <Form.Item style={{ marginBottom: 6 }}>
        <Button
          type="primary"
          size="large"
          htmlType="submit"
          loading={isLoading}
          block
        >
          {t("pages.login.signup", "Sign Up")}
        </Button>
      </Form.Item>
      <hr />
      <div
        style={{
          marginTop: 8,
          textAlign: "center",
        }}
      >
        <Typography.Text style={{ fontSize: 12 }}>
          {t("pages.login.buttons.haveAccount", "Have an account?")}{" "}
          <Link
            to="/login"
            style={{
              fontWeight: "bold",
              color: token.colorPrimaryTextHover,
            }}
          >
            {t("pages.login.signin", "Sign in")}
          </Link>
        </Typography.Text>
      </div>
    </Form>
  );

  return (
    <div className={styles.loginContainer}>
      <div
        className={styles.formContainer}
        style={{
          paddingTop: '15px',
          borderRadius: "5%",
          maxHeight: "715px",
          height: "auto",
          maxWidth: "470px",
          width: "470px",
        }}
      >
        <div className={styles.pageTitle}>
          {/* <AIOpsLogo /> */}
          <span
            style={{
              color: token.colorPrimary,
              fontSize: "28px",
              fontWeight: 700,
            }}
          >
            {t("auth.loginFormTitle", "VIA AIOps")}
          </span>
        </div>
        {adminSignupForm}
      </div>
    </div>
  );
};

export const PasswordRule = (t) => [
  {
    min: 8,
    message: t(
      "pages.login.errors.passwordMinLength",
      "Password must be at least 8 characters.",
    ),
  },
  // {
  //   validator(_, value) {
  //     if (
  //       !value ||
  //       /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(
  //         value,
  //       )
  //     ) {
  //       return Promise.resolve();
  //     }
  //     return Promise.reject(
  //       new Error(
  //         t(
  //           "pages.login.errors.passwordStrength",
  //           "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character.",
  //         ),
  //       ),
  //     );
  //   },
  // },
];

// import { AuthPage } from "@refinedev/antd";

// const authCredentials = {
//   email: "demo@demo.com",
//   password: "demodemo",
// };

// export const RegisterPage = () => {
//   return (<AuthPage
//     type="register"
//     formProps={{
//       initialValues: {
//         ...authCredentials,
//       },
//     }}
//     renderContent={(content, title) => {
//       return content;
//     }}
//   />);
// };
